import Editor from './Editor.jsx'

export default Editor
